import React, { useEffect, useState } from 'react'
import Post from './Post'
import ReactPaginate from "react-paginate";
import Pagination from '@mui/material/Pagination';
import Footer from '../../../sub-components/Footer';
import CommonHeader from '../../../sub-components/CommonHeader';
import MenuCategory from '../../../sub-components/MenuCategory';
import { db } from '../../../firebase';

function FavMenus({ uid }) {
  const [posts, setPosts] = useState([])
  const [pageNumber, setPageNumber] = useState(0);
  const [input, setInput] = useState("");
  const [posts1, setPosts1] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);

  
  useEffect(() => {
    db.collection('users').doc(uid).collection("Favourites").where("fromId","==", uid).onSnapshot((snapshot) => {
      setPosts1(snapshot.docs.map((doc) => doc.data()))
    })

    if (posts1 !== undefined) {
      const finalPosts = posts1.filter(res => {
        return res.menuName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
      })

      setFilteredPosts(finalPosts)
    }else {
      return <div>No results3</div>
    }
  }, [searchTerm])

  const updateSearchResults = (e) => {
    setSearchTerm(e.target.value)
    // document.getElementsByClassName('dropdown-content3')[0].style.display = 'auto';
  }

  const totalRatings = (posts.reduce((a,v) =>  a = a + v.post.rating , 0 ))
  const numberOfRatings = posts.length
  const rating = totalRatings / numberOfRatings
  var a = Math.round(rating * 10) / 10

  //  useEffect(() => {
  //      db.collection('menus').where("branchId","==", branchId).onSnapshot(snapshot => {
  //          setPosts(snapshot.docs.map(doc => ({
  //              id: doc.id,
  //              post: doc.data(),
               
  //          },
  //          console.log("Posts: ",post)
  //          )));
  //      })
  //  }, []);
   useEffect(()=>{
    const unsuscribe = db.collection('users').doc(uid).collection("Favourites").where("fromId","==", uid).onSnapshot(snapshot =>{
      setPosts(snapshot.docs.map(doc =>({
           id:doc.id,
           post:doc.data()
       })))
    })
    return unsuscribe
  },[])
   console.log("Posts: ",posts)


   const menusPerPage = 8;
   const pagesVisited = pageNumber * menusPerPage;

   const displayMenus = <div>
        {/* <div><MenuCategory /></div> */}
       <section style={{marginTop:-70}} className="section pt-5 pb-5 products-listing">
         <div className="container">
           {/* <div className="row d-none-m">
             <div className="col-md-12">
               <h4 className="font-weight-bold mt-0 mb-3">MENUs Categories<small className="h6 mb-0 ml-2">
                 </small>
               </h4>
             </div>
           </div> */}
           <div>
         {/* SideBar here */}
             <div className="">
             {/* <MenuCategory /> */}
             <hr />
                           <div className="row d-none-m">
             <div className="col-md-12">
               <div className="dropdown float-right">
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">All</span> &nbsp;&nbsp;
                 </a>
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">Newest</span> &nbsp;&nbsp;
                 </a>
                 <a className="btn btn-outline-info btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                   Sort by: <span className="text-theme">Ratings</span> &nbsp;&nbsp;
                 </a>
               </div>

             </div>
           </div>
           <hr />
           <form className="explore-outlets-search mb-4 rounded overflow-hidden border">
       <div className="input-group">
         <input type="text" onChange={updateSearchResults} placeholder="Search for menus..." className="form-control border-0" />
         <div className="input-group-append">
           <button type="button" className="btn btn-primary">
             <i className="icofont-search" />
           </button>
         </div>
       </div>
     </form>
             <div className="product-list-view">
   
           <div className="row">
             {searchTerm === "" ?(
                  <>
                             {
             // hakuna > || iko < 
             posts.length > 0 ?(
               <>
               {
                              posts.slice(pagesVisited, pagesVisited + menusPerPage).map(({id, post}) => (
                                 <Post
                                 key={id} 
                                 mealImage={post.mealImage}
                                 branchId={post.branchId}
                                 createdById={post.createdBy}
                                 mealArrayIds={post.mealArrayIds}
                                 menuName={post.menuName}
                                 menuCategories={post.menuCategories}
                                 rating={post?.rating}
                                 restId={post.restId}
                                 timestamp={post.timestamp}
                                 menuAvailability={post?.menuAvailability}
                                 menuId={id}
                                 numberOfRatings={post?.numberOfRatings}
                                 totalRates={a}
                                 restaurant={post?.restaurant}
                                 />
                               ))
               }
               </>
             ) : (<>  <center><i style={{fontSize:18,fontWeight:'bold'}}>No Menus!</i></center>
             </>)  
   } 
                  </>
             ):(
               <>
                            <div className="product-list-view">
   <div className="row">
            {
              filteredPosts.length > 0 ?(
                <>
                {
                                filteredPosts.map((posts2) => (

<Post 
mealImage={posts2.mealImage}
branchId={posts2.branchId}
createdById={posts2.createdBy}
mealArrayIds={posts2.mealArrayIds}
menuName={posts2.menuName}
menuCategories={posts2.menuCategories}
rating={posts2?.rating}
restId={posts2.restId}
timestamp={posts2.timestamp}
menuAvailability={posts2?.menuAvailability}
menuId={posts2?.menuId}
numberOfRatings={posts2?.numberOfRatings}
totalRates={a}
restaurant={posts2.restaurant}
/>
    ))
                                }
                </>
              ):(
                <><center style={{fontWeight:'bold'}}><h4>No results...</h4></center></>
              )

              
            
            }
          </div>
          </div>
               </>
             )}

     </div>
     </div>
   
              
   
             </div>
           </div>
         </div>
       </section>
   
   
   
   
   </div>

 const pageCount = Math.ceil(posts.length / menusPerPage);
 const changePage = ({ selected }) => {
   setPageNumber(selected);
 };


  return (
   <div>
     {displayMenus}
     <center>
       
     <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
     </center>

   </div>
  )
}

export default FavMenus




